module.exports = __webpack_public_path__ + "img/gongsijianjie.cd30263a.png";